export default "__VITE_ASSET__eef12c9b__"